import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import uuid from 'uuid'
import styles from './breadcrumbs.styl'
import config from 'config'

export default class Breadcrumbs extends Component {
  static propTypes = {
    location: PropTypes.object
  }

  getIndicesOf = (searchStr, str) => {
    const searchStrLen = searchStr.length
    if (searchStrLen === 0) {
      return []
    }
    let startIndex = 0, index, indices = []
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
      indices.push(index)
      startIndex = index + searchStrLen
    }
    return indices
  }

  parseLocation = pathname => {
    // eslint-disable-next-line no-useless-escape
    const regex = /\/([^\/0-9]+)$/  // excluding only digits sequence, like :id params
    let items = []

    if (pathname) {
      const normPathName = pathname.startsWith(config.publicPath)
        ? pathname.substring(config.publicPath.length)
        : pathname

      const indices = this
        .getIndicesOf('/', normPathName + '/')
        .slice(1)

      for (let index of indices) {
        const subPath = normPathName.substring(0, index)
        const regexMatch = regex.exec(subPath)
        if (regexMatch) {
          items.push({
            path: subPath,
            link: `${config.publicPath}${subPath}`,
            lastPart: regexMatch[1]
          })
        }
      }
    }

    return items
  }

  render() {
    const { location } = this.props
    const links = this.parseLocation(location.pathname)

    return (
      <ul className={styles.list}>
        {links.map((item, index) => {
          return (
            <li className={styles.item} key={uuid.v1()}>
              {index !== links.length - 1
                ? <Link className={styles.link} to={item.link}>
                    <FormattedMessage
                      id={`route.${item.lastPart}`}
                      defaultMessage={item.lastPart}
                    />
                  </Link>
                : <span className={styles.text}>
                    <FormattedMessage
                      id={`route.${item.lastPart}`}
                      defaultMessage={item.lastPart}
                    />
                  </span>}
            </li>
          )
        })}
      </ul>
    )
  }
}
